// extracted by mini-css-extract-plugin
export default {"Item":"ProductListItems_Item__ESiPl","imgConainer":"ProductListItems_imgConainer__bNWBo","price":"ProductListItems_price__0chmK","discripion":"ProductListItems_discripion__tCLNT"};